<template>
  <div class="registered">
    <el-button type="text" @click="register">注册</el-button>
    <el-dialog title="用户注册" :visible.sync="dialogFormVisible" width="20%" @close="closeForm(registerFormEmail)" :close-on-click-modal="false" :close-on-press-escape="false"	>
      <el-container>
        <div class="reg">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="邮箱注册" name="emailSignUp">
              <el-form
                :model="registerFormEmail"
                status-icon
                :rules="rules"
                ref="registerFormEmail"
                style="height:250px"
              >
                <el-form-item prop="email">
                  <el-input type="text" v-model="registerFormEmail.email" placeholder="请输入邮箱:"></el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input
                    type="password"
                    v-model="registerFormEmail.pass"
                    placeholder="请输入密码:"
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                  <el-input
                    type="password"
                    v-model="registerFormEmail.checkPass"
                    placeholder="请再输入一遍密码:"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="registerForm('registerFormEmail')">立即注册</el-button>
                  <el-row>
                    已有账号立即
                    <a href="javascript:void(0)" @click="loginIn">登录</a>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="手机号注册" name="phoneSignUp">
              <el-form
                :model="registerFormPhone"
                status-icon
                :rules="rules"
                ref="registerFormPhone"
                style="height:250px"
              >
                <el-form-item prop="phonenumber">
                  <el-input
                    type="text"
                    v-model.number="registerFormPhone.phonenumber"
                    placeholder="请输入手机号:"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="activationOrder">
                  <el-input
                    v-model="registerFormPhone.activationOrder"
                    auto-complete="autoComplete"
                    placeholder="验证码"
                    style="width:150px;float:left;"
                    @keyup.enter.native="handleLogin"
                  >
                    <svg-icon
                      slot="prefix"
                      icon-class="validCode"
                      class="el-input__icon input-icon"
                    />
                  </el-input>
                  <div class="login-code">
                    <el-button :disabled="isDisabled" @click="registerCaptcha">
                      <span>{{buttonName}}</span>
                    </el-button>
                  </div>
                </el-form-item>

                  <el-form-item prop="code">
                    <el-input
                      v-model="registerFormPhone.code"
                      auto-complete="off"
                      placeholder="验证码"
                      style="width: 63%"
                      @keyup.enter.native="handleLogin"
                    >
                      <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
                    </el-input>
                    <div class="login-code">
                      <img :src="codeUrl" @click="getCode" class="login-code-img"/>
                    </div>
                  </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="registerForm('registerFormPhone')">立即注册</el-button>
                  <el-row>
                    已有账号立即
                    <a href="javascript:void(0)" @click="loginIn">登录</a>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-container>
    </el-dialog>
    <el-dialog title="用户登录" :visible.sync="dialogFormVisible1" width="20%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-container>
        <div class="reg">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="邮箱登录" name="emailSignUp">
              <el-form
                :model="loginFormEmail"
                status-icon
                :rules="rules"
                ref="loginFormEmail"
                style="height:250px"
              >
                <el-form-item prop="email">
                  <el-input type="text" v-model="loginFormEmail.email" placeholder="请输入邮箱:"></el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input
                    type="password"
                    v-model="loginFormEmail.pass"
                    placeholder="请输入密码:"
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="loginForm('loginFormEmail')">登录</el-button>
                  <el-row>
                    没有账号?立即
                    <a href="javascript:void(0)" @click="register">注册</a>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="手机号登录" name="phoneSignUp">
              <el-form
                :model="loginFormPhone"
                status-icon
                :rules="rules"
                ref="loginFormPhone"
                style="height:250px"
              >
                <el-form-item prop="phonenumber">
                  <el-input
                    type="text"
                    v-model.number="loginFormPhone.phonenumber"
                    placeholder="请输入手机号:"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="activationOrder">
                  <el-input
                    v-model="loginFormPhone.activationOrder"
                    auto-complete="autoComplete"
                    placeholder="验证码"
                    style="width:150px;float:left;"
                    @keyup.enter.native="handleLogin"
                  >
                    <svg-icon
                      slot="prefix"
                      icon-class="validCode"
                      class="el-input__icon input-icon"
                    />
                  </el-input>
                  <div class="login-code">
                    <el-button :disabled="isDisabled" @click="loginCaptcha">
                      <span>{{buttonName}}</span>
                    </el-button>
                  </div>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="loginForm('loginFormPhone')">登录</el-button>
                  <el-row>
                    没有账号?立即
                    <a href="javascript:void(0)" @click="register">注册</a>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Registered",
  data() {
    var email = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.registerFormEmail.checkPass !== "") {
          this.$refs.registerFormEmail.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerFormEmail.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
        // 所以在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };

    return {
      codeUrl: "",
      buttonName: "发送短信",
      isDisabled: false,
      time: 60,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      //注册
      //邮箱
      registerFormEmail: {
        email: "",
        pass: "",
        checkPass: "",
        userType: "01",
         code: "",
        uuid: ""
      },
      //手机
      registerFormPhone: {
        phonenumber: "",
        activationOrder: "",
        remark: "", //缺少字段,备注代替(uuid) 无影响
        userType: "01",
          code: "",
        uuid: ""
      },
      //登录
      //邮箱
      loginFormEmail: {
        email: "",
        pass: ""
      },
      //手机
      loginFormPhone: {
        phonenumber: "",
        activationOrder: "",
        remark: "" //缺少字段,备注代替(uuid) 无影响
      },
      activeName: "phoneSignUp",
      rules: {
        email: [{ validator: email, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        phonenumber: [{ validator: checkPhone, trigger: "blur" }],
        activationOrder: [
          { required: true, trigger: "change", message: "验证码不能为空" }
        ],
        code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      }
    };
  },
    created() {
    this.getCode();
    this.getCookie();
  },
  methods: {
     getCode() {

      var api = this.systemURL + "/actuator/user/createCapcha";
      var params = {};
       this.axios.post(api, params).then(res => {
        this.codeUrl = "data:image/gif;base64," + res.data.img;
        this.registerFormEmail.uuid = res.data.uuid;

       })

     /*  getCodeImg().then(res => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      }); */
    },
    registerCaptcha() {
      //发送手机验证码 注册
      var api = this.systemURL + "/actuator/user/getCaptcha";
      var params = {
        phonenumber: this.$data.registerFormPhone.phonenumber ? "" : this.$data.loginFormPhone.phonenumber
      };
      this.axios.post(api, params).then(res => {
        console.log(res.data.msg);
        if (res.data.code == 500) {
          this.$message.error(res.data.msg);
        }
        this.isDisabled = true;
        this.registerFormPhone.remark = res.data.uuid;
        let interval = window.setInterval(() => {
          this.buttonName = "(" + this.time + "秒)后重送";
          --this.time;
          if (this.time < 0) {
            this.buttonName = "重新发送";
            this.time = 60;
            this.isDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);
      });
    },
    loginCaptcha() {
      //发送手机验证码 登录
      var api = this.systemURL + "/actuator/user/getCaptcha";
      var params = {
        phonenumber: this.$data.loginFormPhone.phonenumber
      };
      this.axios.post(api, params).then(res => {
        console.log(res.data.msg);
        if (res.data.code == 500) {
          this.$message.error(res.data.msg);
        }
        this.isDisabled = true;
        this.loginFormPhone.remark = res.data.uuid;
        let interval = window.setInterval(() => {
          this.buttonName = "(" + this.time + "秒)后重送";
          --this.time;
          if (this.time < 0) {
            this.buttonName = "重新发送";
            this.time = 60;
            this.isDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);
      });
    },
    registerForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //信息填写完毕发送邮件
          var api = this.systemURL + "/actuator/user/registeredAdd";
          if (formName == "registerFormEmail") {
           //邮件
            var params = {
              email: this.$data.registerFormEmail.email,
              password: this.$data.registerFormEmail.pass,
              userType: this.registerFormEmail.userType
            };
          } else {
            //手机短信
            var params = {
              phonenumber: this.$data.registerFormPhone.phonenumber,
              activationOrder: this.$data.registerFormPhone.activationOrder,
              remark: this.registerFormPhone.remark,
              userType: this.registerFormPhone.userType
            };
          }
          this.axios.post(api, params).then(res => {
            console.log(res.data.msg);
            if (res.data.code == 500) {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    loginForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          //信息填写完毕发送邮件
          var api = this.systemURL + "/actuator/user/loginWebsite";
          if (formName == "loginFormEmail") {
             //邮件
            var params = {
              email: this.$data.loginFormEmail.email,
              password: this.$data.loginFormEmail.pass
            };
          } else {
            //手机短信
            var params = {
              phonenumber: this.$data.loginFormPhone.phonenumber,
              activationOrder: this.$data.loginFormPhone.activationOrder,
              remark: this.loginFormPhone.remark
            };
          }
          this.axios.post(api, params).then(res => {
            console.log(res.data.msg);
            if (res.data.code == 500) {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm(registerFormEmail){
       this.$refs[registerFormEmail].resetFields();
    },
    /*  resetForm(formName) {
      this.$refs[formName].resetFields();
    } */
    loginIn() {
      this.dialogFormVisible = false;
      this.dialogFormVisible1 = true;
    },
    register() {
      this.dialogFormVisible1 = false;
      this.dialogFormVisible = true;
    }
  }
};
</script>

<style >
.registered {
  width: 100%;
}
.registered .el-tabs__nav {
  width: 100%;
  float: none;
}
.registered .el-tabs__active-bar {
  background-color: #e4e7ed;
  height: 0px;
}
.registered .el-radio-group {
  float: left;
  position: relative;
  top: 12px;
}
.registered .el-tabs__item {
  padding: 0;
  background: #f9f9f9;
  width: 50%;
}
.registered .el-tabs__item.is-active {
  color: white;
  background: #0c70fc;
}
.registered .el-tabs__nav-wrap::after {
  background-color: white;
}
.registered .el-dialog .el-dialog__body {
  padding: 30px 60px !important;
}
/* .el-dialog__headerbtn.el-dialog__headerbtn .el-dialog__close {
  display: none;
} */
.registered .el-form-item__content .el-button--primary {
  width: 100%;
}
.registered .login-code .el-button {
  width: 110px;
}
</style>



// WEBPACK FOOTER //
// src/views/Registered.vue